export function createMultipartRequestBody<T = any, TParam extends T | null | undefined = T>(
  createFormData: (formData: FormData) => void,
  params?: TParam,
  paramsName = 'request'
): T {
  const formData = new FormData();
  if (params) {
    formData.append(paramsName, JSON.stringify(params));
  }
  if (createFormData) {
    createFormData(formData);
  }
  // cast to T for easier usage with RTKQ (Codegen does not yet support multipart/form-data correctly)
  return formData as T;
}
